define('collection/BookingCollection',['require','lib/collection/BaseCollection','model/BookingModel'],function (require) {
	
	var BaseCollection = require('lib/collection/BaseCollection');
	var BookingModel = require('model/BookingModel');
	
	/**
	 * Bookings collection list
	 * 
	 * @class BookingCollection
	 */
	return BaseCollection.extend({

		url: '/booking/',
		model: BookingModel
		
	});
	
});
